module.exports = __webpack_public_path__ + "static/media/illustration-element-05.24e65476.svg";